import React from 'react';
import Tooltip from "./Tooltip";

const LockedMessage = ({ message, Unsent, tooltip, messageColor, iconWidth = 20, iconHeight = 20 }) => {

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            backgroundColor: '#f4f5f7',
            border: '1px solid #d1d1d1',
            borderRadius: '8px',
            padding: '10px 14px',
            position: 'relative',
            maxWidth: '600px',
            fontSize: '14px',
        }}>
            <Tooltip text={tooltip}>
                <img
                    width={iconWidth}
                    height={iconHeight}
                    src={Unsent}
                    alt="Locked"
                    style={{
                        cursor: 'pointer',
                        filter: 'grayscale(100%) opacity(0.8)'
                    }}
                />
            </Tooltip>

            <span style={{ color: messageColor || '#333', flex: 1 }}>
                {message.text}
            </span>

        </div>
    );
};

export default LockedMessage;



// WEBPACK FOOTER //
// ./src/components-new/LockedMessage.jsx